// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-editor-page {
  display: block;
  height: 100%;
  overflow: auto;
  background-color: var(--fi-background-color-extra-light);
}
fi-editor-page.fi-editor-page-sidebar-positioning-static .fi-edit-page-sidebar {
  position: static;
  margin-top: 10px;
  width: auto;
}
fi-editor-page.fi-editor-page-sidebar-positioning-static .fi-edit-page-content, fi-editor-page.fi-editor-page-no-sidebar .fi-edit-page-content {
  margin-left: auto;
  margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/fi-editor-page/fi-editor-page.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,YAAA;EACA,cAAA;EACA,wDAAA;AACJ;AAEQ;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;AAAZ;AAMQ;EACI,iBAAA;EACA,kBAAA;AAJZ","sourcesContent":["fi-editor-page {\r\n    display: block;\r\n    height: 100%;\r\n    overflow: auto;\r\n    background-color: var(--fi-background-color-extra-light);\r\n\r\n    &.fi-editor-page-sidebar-positioning-static {\r\n        .fi-edit-page-sidebar {\r\n            position: static;\r\n            margin-top: 10px;\r\n            width: auto;\r\n        }\r\n    }\r\n\r\n    &.fi-editor-page-sidebar-positioning-static,\r\n    &.fi-editor-page-no-sidebar {\r\n        .fi-edit-page-content {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
